var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Keypair } from '@solana/web3.js';
import { ethers } from 'ethers';
import { useLocalStorage } from 'usehooks-ts';
import { toast } from 'sonner';
import bs58 from 'bs58';
import { useRouter } from 'next/router';
import crypto from 'crypto';
import { useSession } from '@/contexts/LitSessionProvider';
export default function useGetWrappedWallet() {
    var _this = this;
    var clearLitSession = useSession().clearLitSession;
    var startDecryption = useLocalStorage('startDecryption', false)[0];
    var _a = useLocalStorage('genius-lit-cached-min-sig', null), litCachedMinSig = _a[0], setLitCachedMinSig = _a[1];
    var decryptionSignature = useLocalStorage('genius-decryption-signature', null)[0];
    var _b = useLocalStorage('cipher1', null), cipher1 = _b[0], setCipher1 = _b[1];
    var _c = useLocalStorage('cipher2', null), cipher2 = _c[0], setCipher2 = _c[1];
    var router = useRouter();
    var getEVMWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var evmWalletLC, encryptionSig, decryptedPrivateKey, wallet;
        var _a;
        return __generator(this, function (_b) {
            if (startDecryption && (!litCachedMinSig || !decryptionSignature || !cipher1 || !cipher2)) {
                toast.info("You're account is still being set up. Please wait a moment.");
                return [2 /*return*/, null];
            }
            try {
                evmWalletLC = cipher1;
                if (!evmWalletLC) {
                    throw new Error('No EVM wallet found');
                    return [2 /*return*/, null];
                }
                else {
                    encryptionSig = (_a = (litCachedMinSig || decryptionSignature)) === null || _a === void 0 ? void 0 : _a.slice(3, 35);
                    decryptedPrivateKey = decrypt(evmWalletLC, encryptionSig);
                    wallet = new ethers.Wallet(decryptedPrivateKey);
                    return [2 /*return*/, wallet];
                }
            }
            catch (error) {
                console.log('WUJI getEVMWallet error', error);
                clearLitSession();
                router.push("/home?message=Your session has expired. You've been logged out to keep your account secure....");
            }
            return [2 /*return*/];
        });
    }); };
    var getSolanaWallet = function () { return __awaiter(_this, void 0, void 0, function () {
        var solanaWalletLC, encryptionSig, decryptedPrivateKey, keypair;
        var _a;
        return __generator(this, function (_b) {
            if (startDecryption && (!litCachedMinSig || !decryptionSignature || !cipher1 || !cipher2)) {
                toast.info("You're account is still being set up. Please wait a moment.");
                return [2 /*return*/, null];
            }
            try {
                solanaWalletLC = cipher2;
                if (!solanaWalletLC) {
                    throw new Error('No Solana wallet found');
                    return [2 /*return*/, null];
                }
                else {
                    encryptionSig = (_a = (litCachedMinSig || decryptionSignature)) === null || _a === void 0 ? void 0 : _a.slice(3, 35);
                    decryptedPrivateKey = decrypt(solanaWalletLC, encryptionSig);
                    keypair = Keypair.fromSecretKey(bs58.decode(decryptedPrivateKey));
                    return [2 /*return*/, keypair];
                }
            }
            catch (error) {
                console.error('[getSolanaWallet]', error);
                clearLitSession();
                router.push("/home?message=Your session has expired. You've been logged out to keep your account secure...");
            }
            return [2 /*return*/];
        });
    }); };
    return {
        getEVMWallet: getEVMWallet,
        getSolanaWallet: getSolanaWallet,
        litCachedMinSig: litCachedMinSig,
        setLitCachedMinSig: setLitCachedMinSig,
        cipher1: cipher1,
        setCipher1: setCipher1,
        cipher2: cipher2,
        setCipher2: setCipher2,
    };
}
var algorithm = 'aes-256-ctr';
export var encrypt = function (text, secretKey) {
    var iv = crypto.randomBytes(16);
    var cipher = crypto.createCipheriv(algorithm, secretKey, iv);
    var encrypted = Buffer.concat([cipher.update(text), cipher.final()]);
    return {
        iv: iv === null || iv === void 0 ? void 0 : iv.toString('hex'),
        content: encrypted === null || encrypted === void 0 ? void 0 : encrypted.toString('hex'),
    };
};
export var decrypt = function (hash, secretKey) {
    var decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(hash.iv, 'hex'));
    var decrpyted = Buffer.concat([
        decipher.update(Buffer.from(hash.content, 'hex')),
        decipher.final(),
    ]);
    return decrpyted === null || decrpyted === void 0 ? void 0 : decrpyted.toString();
};
